import {
  faArrowsRotate,
  faAward,
  faIndianRupeeSign,
  faStore,
} from "@fortawesome/free-solid-svg-icons";

export const aboutImages = {
  team: "https://images.pexels.com/photos/1181370/pexels-photo-1181370.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const teamParagraphs = [
  "We are a team of dynamic and experienced engineers with over 50 years of combined experience in the international equipment manufacturing industry, offering our services in strategic sourcing from India.",
  "The team has successfully led and executed many international product projects. Our project handling protocols are industry proven and share complete transparency and milestone monitoring at every stage of the project.",
  "Quality processes are in place, ensuring optimum quality from every vendor during development and serial production.",
  "Our senior sourcing team is highly familiar with the casting, forging, steel fabrication and other engineering markets, sensitive to market prices, with quick responses and actions to meet flexible procurement needs on time.",
];

export const whyChooseUs = [
  {
    id: 1,
    icon: faArrowsRotate,
    title: "Flexibility",
    body: "Our senior sourcing team knows the casting and forging markets well and stays sensitive to market prices, responding quickly to meet your procurement needs as they change.",
  },
  {
    id: 2,
    icon: faAward,
    title: "Experience",
    body: "A team with the strategic thinking and sector experience to have led and executed many international product projects from start to finish.",
  },
  {
    id: 3,
    icon: faIndianRupeeSign,
    title: "India, as Low Cost Quality Supplier",
    body: "India stands as a premier low-cost, high-quality manufacturing base, offering exceptional value and reliability to global industries.",
  },
  {
    id: 4,
    icon: faStore,
    title: "One Stop Shop",
    body: "We are your versatile partner for all sourcing needs, offering a comprehensive range of high-quality mechanical and electrical parts.",
  },
];
